import { Pipe, PipeTransform, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ModulesDataService } from '../services/data/modules-data.service';

@Pipe({
  name: 'hasPermission',
  pure: true
})
export class PermissionPipe implements PipeTransform {
  private authService = inject(AuthService); // Auto-inject AuthService
  private modulesDataService = inject(ModulesDataService); // Auto-inject ModulesDataService

  transform(moduleName: string, permissionType: 'create' | 'read' | 'update' | 'delete'): boolean {
    // ✅ If user is a Group Owner/Admin, they always have permission
    if (this.authService.isGroupOwner()) {
      return true;
    }

    if (!moduleName || !permissionType) {
      console.warn('PermissionPipe: Missing module name or permission type');
      return false;
    }

    const module = this.modulesDataService.findModuleByName(moduleName);

    // ✅ If the module doesn't exist, only Group Owner gets access
    if (!module || !module.id) {
      console.warn(`PermissionPipe: Module '${moduleName}' not found`);
      return false;
    }

    // ✅ Check if user has the requested permission
    return this.authService.hasPermissionTo(module.id, permissionType);
  }
}
